import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_org/org/jobs/post/")({
  validateSearch: z.object({
    sortBy: z
      .enum(["alphabetical", "createdAt", "recentlyInterested"])
      .optional()
      .default("recentlyInterested"),
    status: z.enum(["active", "closed"]).optional().default("active"),
    searchTerm: z.string().optional(),
    specialtyId: z.string().optional(),
    facilityId: z.string().optional(),
  }),
  beforeLoad: ({ context, search }) => {
    const organizationBusinessUnitId = (
      context as { savedOrgBusinessUnit?: { id?: string } }
    ).savedOrgBusinessUnit?.id;
    if (!organizationBusinessUnitId) {
      throw redirect({ to: "/org/providers" });
    }
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/jobs/post",
      params: { organizationBusinessUnitId },
      search,
    });
  },
});
